import React from "react";
import { useTranslation } from "react-i18next";
import { formatNumberEn } from "../../utils/digits";

export default function FemaleLevelCarousel({
  levels = [],
  realLevel = 0,
  previewLevel = null,
  onSelectLevel,
}) {
  const { t } = useTranslation();

  const safeRealLevel = Number(realLevel || 0);
  const maxLevel = levels.length ? Number(levels[levels.length - 1]?.level ?? 0) : 0;

  return (
    <div className="femaleLevelCarouselWrap">
      <div className="femaleLevelCarousel">
        {levels.map((item) => {
          const lv = Number(item?.level ?? 0);
          const requiredTokens = Number(item?.requiredTokens ?? 0);
          const requiredDays = Number(item?.requiredDays ?? 0);

          const isCurrent = lv === safeRealLevel;
          const isSelected =
            previewLevel === lv || (previewLevel === null && isCurrent);
          const isLocked = lv > safeRealLevel;
          const isPassed = lv < safeRealLevel;
          const isMaxLevel = lv === maxLevel;

          return (
            <button
              key={lv}
              type="button"
              className={[
                "femaleLevelCard",
                isSelected ? "active" : "",
                isCurrent ? "current" : "",
                isLocked ? "locked" : "",
                isPassed ? "passed" : "",
                isMaxLevel ? "max" : "",
              ].join(" ")}
              onClick={() => {
                if (isLocked) return;
                onSelectLevel?.(lv);
              }}
            >
              <div className="femaleLevelCardTop">
            <span>
              {t("female_level.overview.levelLabel", {
                defaultValue: "Lv{{level}}",
                level: lv,
              })}
            </span>
              </div>

              <div className="femaleLevelCardMain">
                <strong>{formatNumberEn(requiredTokens)}</strong>
                <span>
                  {t("tokens.unit", {
                    defaultValue: "Token",
                  })}
                </span>
              </div>

              <div className="femaleLevelCardBottom">
                {lv <= 1 ? (
                  <small>
                    {t("female_level.requirements.noDaysForLevelZero", {
                      defaultValue: "بدون شرط زمني",
                    })}
                  </small>
                ) : (
                  <small>
                    {formatNumberEn(requiredDays)}{" "}
                    {t("female_level.carousel.daysLabel", {
                      defaultValue: "أيام",
                    })}
                  </small>
                )}
              </div>

              <div className="femaleLevelCardState">
                {isCurrent ? (
                  <small>
                    {t("female_level.overview.currentLevel", {
                      defaultValue: "مستواك الحالي",
                    })}
                  </small>
                ) : isPassed ? (
                  <small>
                    {t("female_level.status.unlockedLevel", {
                      defaultValue: "تم الوصول",
                    })}
                  </small>
                ) : (
                  <small>
                    {t("female_level.status.lockedLevel", {
                      defaultValue: "مغلق",
                    })}
                  </small>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
